import {StateCreator} from 'zustand'

interface GameEndControls {
    onClickStatsOrReplay: () => void
    onClickShareReplay: () => void
    onClickShareGameResults: () => void
}

export interface GameEndSlice {
    gameEnd: {
        isVisible: boolean
        setIsVisible: (isVisible: boolean) => void
        isAfterLiveGame: boolean
        setIsAfterLiveGame: (isAfterLiveGame: boolean) => void
        endControls?: GameEndControls
        setEndControls: (endControls: GameEndControls) => void
    }
}

export const createGameEndSlice = (): StateCreator<GameEndSlice> => (set, get) => ({
    gameEnd: {
        isVisible: false,
        setIsVisible: (isVisible) => set({
            gameEnd: {
                ...get().gameEnd,
                isVisible: isVisible,
            },
        }),
        isAfterLiveGame: false,
        setIsAfterLiveGame: (isAfterLiveGame) => set({
            gameEnd: {
                ...get().gameEnd,
                isAfterLiveGame: isAfterLiveGame,
            },
        }),
        setEndControls: (endControls) => set({
            gameEnd: {
                ...get().gameEnd,
                endControls: endControls,
            },
        }),
    },
})
